"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntaxKind = void 0;
var SyntaxKind;
(function (SyntaxKind) {
    SyntaxKind[SyntaxKind["OrOperation"] = 0] = "OrOperation";
    SyntaxKind[SyntaxKind["AndOperation"] = 1] = "AndOperation";
    SyntaxKind[SyntaxKind["NotOperation"] = 2] = "NotOperation";
    SyntaxKind[SyntaxKind["EqualOperation"] = 3] = "EqualOperation";
    SyntaxKind[SyntaxKind["NotEqualOperation"] = 4] = "NotEqualOperation";
    SyntaxKind[SyntaxKind["GreaterThanOperation"] = 5] = "GreaterThanOperation";
    SyntaxKind[SyntaxKind["GreaterThanOrEqualOperation"] = 6] = "GreaterThanOrEqualOperation";
    SyntaxKind[SyntaxKind["LessThanOperation"] = 7] = "LessThanOperation";
    SyntaxKind[SyntaxKind["LessThanOrEqualOperation"] = 8] = "LessThanOrEqualOperation";
    SyntaxKind[SyntaxKind["MatchOperation"] = 9] = "MatchOperation";
    SyntaxKind[SyntaxKind["NotMatchOperation"] = 10] = "NotMatchOperation";
    SyntaxKind[SyntaxKind["SubsetOperation"] = 11] = "SubsetOperation";
    SyntaxKind[SyntaxKind["NotSubsetOperation"] = 12] = "NotSubsetOperation";
    SyntaxKind[SyntaxKind["SupersetOperation"] = 13] = "SupersetOperation";
    SyntaxKind[SyntaxKind["NotSupersetOperation"] = 14] = "NotSupersetOperation";
    SyntaxKind[SyntaxKind["BooleanLiteral"] = 15] = "BooleanLiteral";
    SyntaxKind[SyntaxKind["CollectionLiteral"] = 16] = "CollectionLiteral";
    SyntaxKind[SyntaxKind["DateLiteral"] = 17] = "DateLiteral";
    SyntaxKind[SyntaxKind["NullLiteral"] = 18] = "NullLiteral";
    SyntaxKind[SyntaxKind["NumberLiteral"] = 19] = "NumberLiteral";
    SyntaxKind[SyntaxKind["RegExpLiteral"] = 20] = "RegExpLiteral";
    SyntaxKind[SyntaxKind["StringLiteral"] = 21] = "StringLiteral";
    SyntaxKind[SyntaxKind["UuidLiteral"] = 22] = "UuidLiteral";
    SyntaxKind[SyntaxKind["Identifier"] = 23] = "Identifier";
})(SyntaxKind = exports.SyntaxKind || (exports.SyntaxKind = {}));
//# sourceMappingURL=syntax-kind.js.map